import { Col, Row } from "antd";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import ItemUnitList from "./itemUnitList";
import { getItemUnitApi } from "../../../api/itemUnit";
import { AddEditItemUnit } from "./AddEditItemUnit";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";
import { getItemType } from "../../../api/type";

const ItemUnit = () => {
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedItemUnit, setPaginatedItemUnit] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");
  const [openUnit, setOpenUnit] = useState(false);

  const [formatedItem, setFormatedItem] = useState<
    { value: string; label: string }[]
  >([]);
  const { isLoading: loadingItem } = useQuery("getItemType", getItemType, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedItem(
        res.data.map((itemTypeId: any) => {
          return { value: itemTypeId.id, label: itemTypeId.name };
        })
      );
    },
  });
  const resetFilters = () => {
    getItemUnit({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedItemUnit(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getItemUnit({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedItemUnit(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getItemUnit({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedItemUnit(res.data);
    });
  };
  const getItemUnit = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ItemUnitMutation(params);
  };

  const { mutateAsync: ItemUnitMutation, isLoading: isItemUnitLoading } =
    useMutation("itemunit", getItemUnitApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenUnit(true)} />
        </Col>
        <Col span={24}>
          <ItemUnitList
            paginatedItemUnit={paginatedItemUnit}
            isItemUnitLoading={isItemUnitLoading}
            ItemUnitMutation={ItemUnitMutation}
            setPaginatedItemUnit={setPaginatedItemUnit}
            filter={filter}
            search={search}
            page={page}
            setPage={setPage}
            tableKey={tableKey}
          />
        </Col>
      </Row>
      {openUnit && (
        <AddEditItemUnit
          openUnit={openUnit}
          setOpenUnit={setOpenUnit}
          formatedItem={formatedItem}
          loadingItem={loadingItem}
          ItemUnitMutation={ItemUnitMutation}
          setPaginatedItemUnit={setPaginatedItemUnit}
          filter={filter}
          search={search}
        />
      )}
    </>
  );
};

export default ItemUnit;
